// extracted by mini-css-extract-plugin
export default {"container":"Editor_container__lHP-3","lang":"Editor_lang__IAyWO","mirror":"Editor_mirror__nMa1P","iframe":"Editor_iframe__e4dh2"};